angular.module('picmonic-common').directive('plsSrcset', [
  function () {
    return {
      priority: 99,
      link: function (scope, element, attr) {
        attr.$observe('plsSrcset', function (value) {
          if (!value) {
            return;
          }

          attr.$set('src', window.pls_config.base_asset_url + value);
          attr.$set(
            'srcset',
            window.pls_config.base_asset_url +
              value +
              ' 1x, ' +
              window.pls_config.base_asset_url +
              value.replace('.', '_2x.') +
              ' 2x'
          );

          //IE 9-11 only
          if (window.document.documentMode) element.prop('src', attr['src']);
        });
      },
    };
  },
]);
